import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.pad-start.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _interopRequireWildcard from "C:/project/\u6587\u5316\u5BAB/code/whg/Web/Web/node_modules/@vue/babel-preset-app/node_modules/@babel/runtime/helpers/esm/interopRequireWildcard";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { fetchSwimmingOrderList, activeWriteOff, activeWriteOffAll, refund } from "@/api/PMS/swimming/swimmingOrder";
import waves from "@/directive/waves";
import detail from "./detail";
import { formatJson } from "@/utils/index";
export default {
  name: "SwimmingOrder",
  components: {
    detail: detail
  },
  directives: {
    waves: waves
  },
  data: function data() {
    return {
      dates: [],
      list: null,
      total: null,
      listLoading: true,
      listQuery: {
        page: 1,
        limit: 10
      },
      title: "",
      id: -1,
      dialogFormVisible: false,
      exLists: []
    };
  },
  created: function created() {
    this.dates = this.getDateFun();
    this.getList();
  },
  methods: {
    getDateFun: function getDateFun() {
      var today = new Date(); // 默认查询三个月

      var threeMonthsAgo = new Date(today.getFullYear(), today.getMonth() - 3, today.getDate());
      return [this.formatDate(threeMonthsAgo), this.formatDate(today)];
    },
    formatDate: function formatDate(date) {
      var year = date.getFullYear();
      var month = String(date.getMonth() + 1).padStart(2, "0");
      var day = String(date.getDate()).padStart(2, "0");
      return "".concat(year, "-").concat(month, "-").concat(day, " 00:00:00");
    },
    handleExitDetail: function handleExitDetail(data) {
      this.$router.push({
        path: "/swim/swim/swimmingCheck",
        query: {
          orderNo: data.orderNo
        }
      });
    },
    handleBackVenue: function handleBackVenue(id) {
      var _this = this;

      this.$confirm("你确定是要退款吗, 是否继续?", "提示").then(function () {
        refund({
          id: id
        }).then(function (response) {
          if (response.data.code === 200) {
            _this.getList();

            _this.$message.success(response.data.message || "退款成功");
          }
        });
      });
    },
    handleExit: function handleExit(id) {
      var _this2 = this;

      this.$confirm("你确定是要单次核销吗, 是否继续?", "提示").then(function () {
        activeWriteOff({
          orderId: id
        }).then(function (response) {
          if (response.data.code === 200) {
            _this2.getList();

            _this2.$message.success(response.data.message && response.data.message !== "success" ? response.data.message : "核销成功");
          }
        });
      });
    },
    handleAllExit: function handleAllExit(id) {
      var _this3 = this;

      this.$confirm("你确定是要全部核销吗, 是否继续?", "提示").then(function () {
        activeWriteOffAll({
          orderId: id
        }).then(function (response) {
          if (response.data.code === 200) {
            _this3.getList();

            _this3.$message.success(response.data.message && response.data.message !== "success" ? response.data.message : "核销成功");
          }
        });
      });
    },
    handCancle: function handCancle(reload) {
      if (reload) {
        this.getList();
      }

      this.dialogFormVisible = false;
    },
    getList: function getList() {
      var _this4 = this;

      this.listLoading = true;

      if (this.dates !== null && this.dates.length > 0) {
        this.listQuery.beginDate = this.dates[0];
        this.listQuery.endDate = this.dates[1];
      } else {
        this.listQuery.beginDate = "";
        this.listQuery.endDate = "";
      }

      fetchSwimmingOrderList(this.listQuery).then(function (response) {
        _this4.list = response.data.data;
        _this4.total = response.data.total;
        _this4.listLoading = false;
      });
    },
    handleFilter: function handleFilter() {
      this.listQuery.page = 1;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      this.listQuery.limit = val;
      this.getList();
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.listQuery.page = val;
      this.getList();
    },
    handleDetail: function handleDetail(id) {
      this.id = id;
      this.title = "订单详情";
      this.dialogFormVisible = true;
    },
    handleExport: function handleExport() {
      var _this5 = this;

      this.exLists = [];
      this.$confirm("你确定要导出游泳订单数据吗, 是否继续?", "提示").then(function () {
        fetchSwimmingOrderList({
          orderNo: _this5.listQuery.orderNo,
          orderName: _this5.listQuery.orderName,
          status: _this5.listQuery.status,
          stuName: _this5.listQuery.stuName,
          stuTel: _this5.listQuery.stuTel,
          beginDate: _this5.listQuery.beginDate,
          endDate: _this5.listQuery.endDate,
          content: _this5.listQuery.content
        }).then(function (response) {
          _this5.exLists = response.data.data;

          _this5.exLists.forEach(function (element) {
            switch (element.isCheck) {
              case "0":
                element.isCheck = element.status == 1 ? "-" : "未核销";
                break;

              case "1":
                element.isCheck = "已核销";
                break;

              case "2":
                element.isCheck = "部分核销";
                break;
            }

            switch (element.status) {
              case 1:
                element.status = "待支付";
                break;

              case 2:
                element.status = "已支付";
                break;

              case 3:
                element.status = "退款中";
                break;

              case 4:
                element.status = "已退款";
                break;
            } // 卡片下发状态转换


            switch (element.cardStatus) {
              case 0:
                element.cardStatusText = "待发送";
                break;

              case 1:
                element.cardStatusText = "下发成功";
                break;

              case 2:
                element.cardStatusText = "下发失败";
                break;

              default:
                element.cardStatusText = "-";
            }
          });

          if (_this5.exLists !== null && _this5.exLists.length > 0) {
            Promise.resolve().then(function () {
              return _interopRequireWildcard(require("@/vendor/Export2Excel"));
            }).then(function (excel) {
              var tHeader = ["订单编号", "项目名称", "报名内容", "微信昵称", "姓名", "联系方式", "订单状态", "订单总金额(元)", "订单创建时间", "订单支付时间", "退款时间", "核销次数", "核销状态", "卡片下发状态", "卡片下发时间", "下发结果/失败原因"];
              var fileterVal = ["orderNo", "orderName", "content", "openName", "stuName", "stuTel", "status", "orderAmount", "createTime", "paySuccessTime", "refundTime", "chickNum", "isCheck", "cardStatusText", "cardSyncDate", "cardSyncResult"];
              var data = formatJson(fileterVal, _this5.exLists);
              excel.export_json_to_excel({
                header: tHeader,
                data: data,
                filename: "游泳订单信息",
                autoWidth: true,
                bookType: "xlsx"
              });
            });
          } else {
            _this5.$message.error("暂无数据，无法导出！");
          }
        });
      });
    }
  }
};